/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ContactsPageData } from './ContactsPageData'
import {
  ContactsPageDataFromJSON,
  ContactsPageDataFromJSONTyped,
  ContactsPageDataToJSON,
} from './ContactsPageData'

/**
 *
 * @export
 * @interface GetContacts200Response
 */
export interface GetContacts200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetContacts200Response
   */
  status: boolean
  /**
   *
   * @type {ContactsPageData}
   * @memberof GetContacts200Response
   */
  data: ContactsPageData
}

/**
 * Check if a given object implements the GetContacts200Response interface.
 */
export function instanceOfGetContacts200Response(
  value: object
): value is GetContacts200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetContacts200ResponseFromJSON(
  json: any
): GetContacts200Response {
  return GetContacts200ResponseFromJSONTyped(json, false)
}

export function GetContacts200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContacts200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: ContactsPageDataFromJSON(json['data']),
  }
}

export function GetContacts200ResponseToJSON(
  value?: GetContacts200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: ContactsPageDataToJSON(value['data']),
  }
}
